import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { InviteCodesBackend } from '@libs/src/invite-codes/invite-codes.backend';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';

@Injectable()
export class InviteCodeResolver implements Resolve<any> {
  constructor(private inviteCodesBackend: InviteCodesBackend) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const inviteCode = route.queryParamMap.get('inviteCode');
    if (!inviteCode) {
      return null;
    }

    return this.inviteCodesBackend.getInviteCode(inviteCode).pipe(
      catchError(() => of({})),
      map((response: { account: Account; group: Group }) => {
        return {
          inviteCode,
          ...response,
        };
      }),
    );
  }
}
